function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

export const config = {
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  contactApiEndpoint: import.meta.env.VITE_CONTACT_API_ENDPOINT || '',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  cryptoCompareApiKey: import.meta.env.VITE_CRYPTO_COMPARE_API_KEY || '',
  
  validate() {
    const { supabaseUrl, supabaseAnonKey } = this;

    // Validate Supabase URL format
    if (supabaseUrl && !isValidUrl(supabaseUrl)) {
      const error = 'Invalid Supabase URL format';
      if (import.meta.env.DEV) {
        console.warn(error);
        return false;
      }
      throw new Error(error);
    }

    // In development, we'll just warn about missing configs
    if (import.meta.env.DEV) {
      if (!supabaseUrl || !supabaseAnonKey) {
        console.warn('Missing required Supabase configuration');
        return false;
      }
      return true;
    }
    
    // In production, we'll throw errors for missing required configs
    if (!supabaseUrl || !supabaseAnonKey) {
      throw new Error('Missing required Supabase configuration');
    }
    return true;
  }
};